import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IReduxState } from "../../../../interfaces/IReduxState";

export const SubjectFolderMasterReadSlice = createSlice({
  name: "SubjectFolderMasterReadSlice",
  initialState: {} as IReduxState<any>,
  reducers: {
    SubjectFolderMasterRead: (state) => {
      state.isLoading = true;
    },
    successSubjectFolderMasterRead: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    failureSubjectFolderMasterRead: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    clearSubjectFolderMasterRead: (state) => {
      state.data = {};
    },
  },
});

export const {
  SubjectFolderMasterRead,
  failureSubjectFolderMasterRead,
  successSubjectFolderMasterRead,
  clearSubjectFolderMasterRead,
} = SubjectFolderMasterReadSlice.actions;

export default SubjectFolderMasterReadSlice.reducer;
